import React from 'react';
import { object, boolean } from 'prop-types';
import styled from 'styled-components';
import { resolve } from 'library/helpers/path-resolver';
import ServiceProviderModalToggle from './components/service-provider-modal-toggle';

import { enforce_url } from 'library/helpers/url';
import { Header5, Header6, BodyText } from 'library/components/text-elements';
import getSearchProviderData from './queries/getServiceProviderData';
import withData from 'util/hoc/with-data';
import Loading from 'components/loading';
import JourneyCard from 'library/components/journey-card';

const StyledServiceProviderWidget = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0.5em;
  max-width: 380px;
  min-width: 300px;

  > * {
    margin-bottom: 1em;
  }
`;

const StyledServiceProvider = styled.div`
  display: flex;
  align-items: center;
`;

const StyledProviderLink = styled(Header6)`
  font-size: 1.13em;
  text-decoration: none;
  font-weight: bold;
  color: inherit;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledRank = styled.div`
  background-color: ${(props) => props.theme.colors.yellow300};
  color: ${(props) => props.theme.colors.blue300};
  display: flex;
  min-width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 4px;
  font-size: 18px;

  &:first-child {
    margin-right: 0.5em;
  }
`;

const ServiceProviderWidget = ({ graph_loading, graph_data }) => {
  const renderServiceProviders = () =>
    graph_data.serviceProviders?.map((provider, index) => (
      <StyledServiceProvider>
        <StyledRank>{index + 1}</StyledRank>
        {provider.website ? (
          <StyledProviderLink
            as="a"
            href={enforce_url(provider.website)}
            target="_blank"
          >
            {provider.title}
          </StyledProviderLink>
        ) : (
          <Header6>{provider.title}</Header6>
        )}
      </StyledServiceProvider>
    ));

  return graph_loading ? (
    <Loading />
  ) : (
    <JourneyCard>
      <StyledServiceProviderWidget>
        <Header5>
          {`Top ${resolve(
            graph_data.serviceProviders,
            '0/service_provider_category/name',
            ''
          )} resources`}
        </Header5>
        {graph_data.serviceProviders?.length ? (
          <>
            {renderServiceProviders()}
            <ServiceProviderModalToggle
              serviceProviders={graph_data.serviceProviders}
            />
          </>
        ) : (
          <BodyText tabIndex={0}>No resources available</BodyText>
        )}
      </StyledServiceProviderWidget>
    </JourneyCard>
  );
};

ServiceProviderWidget.displayName = 'ServiceProviderWidget';

ServiceProviderWidget.propTypes = {
  meta_data: object,
  graph_data: object,
  graph_loading: boolean,
};

ServiceProviderWidget.query = async (token, { meta_data }) => {
  let category_id = meta_data[0]?.id;
  return await getSearchProviderData({ sp_category_id: category_id });
};
ServiceProviderWidget.parseQueryData = (data) => {
  return {
    serviceProviders: data.search_service_providers?.results,
  };
};

export default withData(ServiceProviderWidget);
